import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SectionTitle = styled(Typography)``;

SectionTitle.defaultProps = {
  variant: 'h6',
};
